<template>
  <div id="login">
    <div class="content">
      <img src="../assets/imgs/login/logo.png" alt class="logo" />
      <div class="flex-between contentBox">
        <div class="systemNameBox">
          <img src="../assets/imgs/login/systemName.png" alt class="systemName" />
        </div>
        <div class="loginBox">
          <div class="inBox">
            <div class="title">
              <p>欢迎您</p>
              <p>使用中资云企业综合服务平台</p>
            </div>
            <div class="inputBox">
              <div class="tabBox flex-around">
                <div class="tab" :class="isPsd ? 'active' : ''" @click="miMa">密码登录</div>
                <div class="tab" :class="isPsd == false ? 'active' : ''" @click="saoMa">扫码登录</div>
              </div>
              <!-- 密码登录 -->
              <div class="inputs" v-if="isPsd">
                <div id="mabox" class="line flex-between" :class="focusPhone ? 'inputChange' : ''">
                  <div class="leftBox" :class="focusPhone ? 'active' : ''">
                    <img :src="phoneUrl" alt />
                  </div>
                  <input placeholder="请输入用户名/手机号" @focus="focusChange('phone')" @blur="blurChange('phone')" @input="inputPhone" v-model="phone" />
                </div>
                <div class="line flex-between" :class="focusPsd ? 'inputChange' : ''">
                  <div class="leftBox" :class="focusPsd ? 'active' : ''">
                    <img :src="psdUrl" alt />
                  </div>
                  <input type="password" v-model="password" placeholder="请输入密码" @focus="focusChange('psd')" @blur="blurChange('psd')" @input="inputPassword" />
                </div>
                <div class="flex-between">
                  <div class="codeinput flex-between" :class="focusCode ? 'inputChange' : ''">
                    <div class="leftBox" :class="focusCode ? 'active' : ''">
                      <img :src="codeUrl" alt />
                    </div>
                    <input placeholder="请输入四位验证码" id="code_input" @focus="focusChange('code')" @blur="blurChange('code')" @input="inputSms" v-model="sms" />
                  </div>
                  <div class="codeBox" id="v_container"></div>
                </div>
                <div class="flex-between error-tip" style="color: red" v-if="show">
                  输入验证码错误,请重新输入
                </div>
                <div class="msgBox flex-between">
                  <p><a @click="register">注册账号</a></p>
                  <p><a @click="forgetPassword">忘记密码？</a></p>
                </div>
              </div>
              <!-- 扫码登录 -->
              <div class="scanBox" v-else>
                <div class="imgbox" id="qrcode" ref="qrcodeDiv"></div>
                <div class="scanMsg">
                  <span>打开手机矿云通扫一扫登录</span>
                </div>
              </div>
              <div v-if="isPsd">
                <button class="login" @click="login">登录</button>
                <div class="downLoad" @click="alert = true">下载矿云通手机端</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <footer>
      <span>Copyright@2015-2020 河南省非煤矿山管理办公室&中资互联网科技 All right
        Reserved</span>
    </footer>
    <!-- 下载弹框 -->
    <div class="alertMask" v-show="alert">
      <div class="alert">
        <div class="alertBox">
          <div class="alertTitle">
            <span>下载矿云通手机端</span>
            <img src="../assets/imgs/login/close.png" @click="alert = false" />
          </div>
          <div class="alertContent">
            <div class="alertTab flex-between">
              <div class="tabItem" :class="alertIndex == 1 ? 'active' : ''" @click="alertIndex = 1">
                手机下载
              </div>
              <div class="tabItem" :class="alertIndex == 2 ? 'active' : ''" @click="alertIndex = 2">
                本地下载
              </div>
            </div>
            <div class="scan" v-show="alertIndex == 1">
              <div class="imgbox" id="qrcode" ref="qrcodeDiv2"></div>
              <p>打开手机微信扫一扫下载</p>
            </div>
            <div class="down" v-show="alertIndex == 2">
              <img src="../assets/imgs/login/app.png" alt />
            </div>
          </div>
          <div class="bottom" v-if="alertIndex == 2">
            <button @click="downloadApk" class="downBut">下载</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GVerify from "../config/bb.js";
import QRCode from "qrcodejs2";
import { mapMutations } from "vuex";
export default {
  data () {
    return {
      isPsd: true, //密码登录
      phoneUrl: require("../assets/imgs/login/user.png"),
      psdUrl: require("../assets/imgs/login/psd.png"),
      codeUrl: require("../assets/imgs/login/code.png"),
      alert: false,
      alertIndex: 1,
      focusPhone: false,
      focusPsd: false,
      focusCode: false,
      allFill: false,
      img: "",
      show: false,
      phone: "",
      password: "",
      sms: "",
      loginTrue: false,
      loginTime: 0,
      kuangYunTongAppDownLoadWeb: "", //矿云通二维码地址
      apkurl: "", //矿云通本地下载地址
      socketUrl: "",
      uuid: "",
    };
  },
  computed: {
    bindModule () {
      const {
        phone,
        password,
        sms
      } = this;
      return {
        phone,
        password,
        sms,
      };
    },
  },
  mounted () {
    this.getImgCode();
    this.enterKeyup();
    this.getInfo();
  },
  methods: {
    ...mapMutations(["setLoginInfo", "setMenuName", "setContentType"]),
    // 注册
    register () {
      this.$router.push({ path: "/register" });
    },
    //忘记密码
    forgetPassword () {
      this.$router.push({ path: "/forgetPass" });
    },
    // 密码登陆
    miMa: function () {
      this.getImgCode();
      if (this.isPsd == false) {
        let imgP = document.getElementsByTagName("canvas");
        if (imgP[0].nextElementSibling.tagName == 'IMG') {
          imgP[0].nextElementSibling.remove();
          imgP[0].remove(imgP[0]);
        }
      }
      this.isPsd = true;
    },
    // 扫码登录
    saoMa: function () {
      this.isPsd = false;
      function getUUID () {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
          return (c === "x" ? (Math.random() * 16) | 0 : "r&0x3" | "0x8").toString(16);
        });
      }
      this.uuid = getUUID();
      setTimeout(() => {
        this.$refs.qrcodeDiv.innerHTML = "";
        let qrcode = new QRCode(this.$refs.qrcodeDiv, {
          text: this.socketUrl, //二维码内容   url填后台给的链接
          width: 270, //控制二维码高度
          height: 270, //控制二维码宽度
          colorDark: "#000000", //控制二维码前景色
          colorLight: "#ffffff", //控制二维码背景色=
          correctLevel: QRCode.CorrectLevel.L, //设置二维码容错率
        });
        this.init();
      }, 500);
    },
    init () {
      let url = this.socketUrl + "/" + this.uuid; // 创建websocket连接
      this.websock = new WebSocket(url); // 监听打开
      this.websock.onopen = this.websockOpen; // 监听关闭
      this.websock.onclose = this.websockClose; //监听异常
      this.websock.onerror = this.websockError; //监听服务器发送的消息
      this.websock.onmessage = this.websockMessage;
    },
    websockOpen () {
      console.log("监听打开");
    },
    websockClose () {
      console.log("监听关闭");
    },
    websockError () {
      console.log("监听异常");
    },
    websockMessage (e) {
      let obj = JSON.parse(e.data);
      for (let i in obj) {
        if (i == "frontPhoto") {
          this.billForm.front = obj[i];
          this.frontErr = false;
        }
        if (i == "backPhoto") {
          this.billForm.back = obj[i];
          this.backErr = false;
        }
      }
      this.modal2 = false;
      // 关闭websock
      this.websock.onclose();
    },
    // 获取登录信息
    getInfo () {
      let data = {
        modeCode: "jgeVwtL1NqOGcbCJHuJCmzqrqcZaVouP",
      };
      this.$http.post(data).then((res) => {
        if (res.code == 1) {
          this.socketUrl = res.data.baseSocketUrl;
          this.apkUrl = res.data.apkUrl1;
          this.kuangYunTongAppDownLoadWeb = res.data.kuangYunTongAppDownLoadWeb;
          this.generateQR();
        } else {
          this.$Message["error"]({
            background: true,
            content: res.msg,
          });
        }
      });
    },
    //生成二维码
    generateQR (index) {
      setTimeout(() => {
        this.$refs.qrcodeDiv2.innerHTML = "";
        var qrcode = new QRCode(this.$refs.qrcodeDiv2, {
          text: this.kuangYunTongAppDownLoadWeb, //二维码内容   url填后台给的链接
          width: 270, //控制二维码高度
          height: 270, //控制二维码宽度
          colorDark: "#000000", //控制二维码前景色
          colorLight: "#ffffff", //控制二维码背景色=
          correctLevel: QRCode.CorrectLevel.L, //设置二维码容错率
        });
      }, 500);
    },
    //点击下载安装包
    downloadApk () {
      window.open(this.apkUrl);
    },
    // 登陆
    login: function () {
      if (!this.phone || !this.password || !this.sms) {
        return;
      }
      this.setMenuName("a");
      this.setContentType(0);
      var val = document.getElementById("code_input").value;
      var res = this.img.validate(val);
      if (res) {
        this.show = false;
        let data = {
          modeCode: "iay4oxl8A17grS8lXUwPdhRFSSZZQa8u",
          userName: this.phone,
          passWord: this.password,
        };
        this.loginTime = this.loginTime + 1;
        if (this.loginTime < 2) {
          this.$http.post(data).then((res) => {
            this.setLoginInfo(res.data);
            localStorage["session"] = JSON.stringify(res.data);
            this.loginTime = 0;
            if (res.code == 1) {
              this.$router.push("/home");
            } else {
              this.$Message["error"]({
                background: true,
                content: res.msg,
              });
              return;
            }
          });
        }
      } else {
        this.show = true;
      }
    },
    // 生成图片验证码
    getImgCode: function () {
      let timeId = setTimeout(() => {
        let aa = document.getElementById("v_container");
        var verifyCode = new GVerify(aa);
        this.img = verifyCode;
      }, 1000);
    },
    //input获取焦点
    focusChange (type) {
      if (type == "phone") {
        this.phoneUrl = require("../assets/imgs/login/usered.png");
        this.focusPhone = true;
      } else if (type == "psd") {
        this.psdUrl = require("../assets/imgs/login/psded.png");
        this.focusPsd = true;
      } else {
        let code = document.getElementById("code_input").value;
        if (code) {
          this.loginTrue = true;
        } else {
          this.loginTrue = false;
        }
        this.codeUrl = require("../assets/imgs/login/coded.png");
        this.focusCode = true;
      }
    },
    // input失去焦点
    blurChange (type) {
      if (type == "phone") {
        this.phoneUrl = require("../assets/imgs/login/user.png");
        this.focusPhone = false;
      } else if (type == "psd") {
        this.psdUrl = require("../assets/imgs/login/psd.png");
        this.focusPsd = false;
      } else {
        let code = document.getElementById("code_input").value;
        if (code) {
          this.loginTrue = true;
        } else {
          this.loginTrue = false;
        }
        this.codeUrl = require("../assets/imgs/login/code.png");
        this.focusCode = false;
      }
    },
    //按钮高亮
    isHigtLight () {
      if (this.phone != "" && this.password != "" && this.sms != "") {
        return true;
      }
    },
    //输入事件
    inputPhone () {
      this.allFill = this.isHigtLight();
    },
    inputPassword () {
      this.allFill = this.isHigtLight();
    },
    inputSms (e) {
      this.allFill = this.isHigtLight();
    },

    enterKey (event) {
      const code = event.keyCode ?
        event.keyCode :
        event.which ?
          event.which :
          event.charCode;
      if (code == 13) {
        this.login();
      }
    },
    enterKeyupDestroyed () {
      document.removeEventListener("keyup", this.enterKey);
    },
    enterKeyup () {
      document.addEventListener("keyup", this.enterKey);
    },
  },
  destroyed () {
    // 销毁enter事件
    this.enterKeyupDestroyed();
  },
  watch: {
    bindModule: {
      handler: function (newVal) {
        if (newVal.phone != "" && newVal.password != "" && newVal.sms != "") {
          let next = document.querySelector(".login");
          next.style.background = "#2C59C3";
          next.style.cursor = "pointer";
        } else {
          let next = document.querySelector(".login");
          next.style.backgroundImage =
            "linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%)";
          next.style.cursor = "default";
        }
      },
    },
  },
};
</script>

<style lang="less" scoped>
#login {
  background: url("../assets/imgs/login/loginBg.png") no-repeat;
  height: 100vh;

  .content {
    .logo {
      float: left;
      margin: 20px 0 120px;
    }
  }

  footer {
    width: 100%;
    height: 54px;
    line-height: 54px;
    text-align: center;
    position: fixed;
    bottom: 0;
    background: #153684;
    font-family: PingFangSC-Medium;
    font-size: 12px;
    color: #ffffff;
    letter-spacing: 0.22px;
  }

  .contentBox {
    clear: both;
    margin: 80px auto;
  }

  /* 系统名称 */
  .systemNameBox {
    margin: 50px 0;
  }

  /* 登录框 */
  .loginBox {
    width: 450px;
    height: 574px;
    background: #ffffff;
    border-radius: 12px;
    cursor: default;

    .inBox {
      width: 368px;
      margin: 30px auto;

      .title {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #2255ce;
        letter-spacing: 0.34px;
        text-align: center;
        font-weight: 600;
      }

      .inputBox {
        margin: 30px auto 15px;
        border-top: 1px solid #d7dce7;

        .tabBox {
          font-family: PingFangSC-Semibold;
          font-size: 16px;
          color: #d7d7d7;
          letter-spacing: 0.3px;
          position: relative;

          .tab {
            text-align: center;
            width: 120px;
            padding: 15px 0;
            font-weight: 600;
            cursor: pointer;
          }

          .tab:first-child::after {
            content: "";
            border-right: 1px solid #d7d7d7;
            height: 20px;
            position: absolute;
            top: 16px;
            left: 50%;
          }

          /* tab选中样式 */
          .tab.active {
            color: #2255ce;
            border-bottom: 1px solid #2255ce;
          }
        }
      }
    }
  }

  /* 输入框 */
  .inputs {
    margin: 40px auto;
    position: relative;

    input {
      height: 48px;
      border: 0;
      outline: none;
      padding-left: 10px;
      width: 322px;
      border-radius: 0 8px 8px 0;
      box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      letter-spacing: 0.3px;
    }

    .error-tip {
      position: absolute;
    }
  }

  /* 占位符样式 */
  .inputs input::-webkit-input-placeholder {
    color: #d7d7d7;
  }

  .input input:-moz-placeholder {
    color: #d7d7d7;
  }

  .input input::-moz-placeholder {
    color: #d7d7d7;
  }

  .input input::-ms-input-placeholder {
    color: #d7d7d7;
  }

  /* input输入框鼠标划过效果 */
  // .inputs input:hover {
  //     box-shadow: inset 0 4px 8px 0 rgba(0, 0, 0, 0.07);
  //     border: 1px solid #bbbbbb;
  // }

  /* input输入框鼠标点击效果 */
  .line {
    border: 1px solid #dfdfdf;
    border-radius: 8px;
    background: #ffffff;
    margin: 15px auto;
  }

  .line:hover {
    border-color: #bbb;
  }

  .inputChange {
    border: 1px solid #2255ce !important;
  }

  .inputs .leftBox {
    width: 47px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    background: #fbfbfb;
    border-right: 1px solid #dfdfdf;
    border-radius: 8px 0 0 8px;
  }

  .inputs .leftBox.active {
    border-right: 1px solid #2255ce !important;
  }

  .inputs .leftBox img {
    vertical-align: middle;
  }

  /* input获取焦点时的图片 */
  .inputs .leftBox .after {
    display: none;
  }

  /* 验证码 */
  .codeinput input {
    width: 165px;
  }

  .codeinput:hover {
    border-color: #bbb;
  }

  .codeinput {
    border: 1px solid #dfdfdf;
    border-radius: 8px;
  }

  .codeBox {
    border: 1px solid #dfdfdf;
    border-radius: 8px;
    width: 130px;
    height: 50px;
  }

  .msgBox {
    float: right;
    width: 130px;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #2255ce;
    letter-spacing: 0.22px;
    margin: 10px 0;
  }

  .msgBox a {
    color: #2255ce;
  }

  .msgBox p:first-child::after {
    content: "";
    border-right: 1px solid #dfdfdf;
    padding-left: 10px;
  }

  /* 扫码登录 */
  .scanBox {
    text-align: center;
    margin: 30px auto 10px;

    .imgbox {
      width: 270px;
      height: 270px;
      margin-left: 45px;
    }
  }

  .scanMsg {
    margin: 20px 0;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0.22px;
  }

  .scanMsg span {
    margin: 0 5px;
  }

  /* 登录按钮 */
  .login {
    width: 368px;
    height: 48px;
    line-height: 48px;
    clear: both;
    background-image: linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%);
    border: 1px solid #b2c9ff;
    border-radius: 8px;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0.3px;
    margin: 30px auto;
  }

  /* 按钮激活样式 */
  .login-active {
    background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
    cursor: pointer;
  }

  .login-normal {
    background-image: linear-gradient(180deg, #d3e2ff 0%, #a8c2ff 100%);
  }

  .downLoad {
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #2255ce;
    letter-spacing: 0.22px;
    text-align: center;
    cursor: pointer;
  }

  /* 弹出层 */
  .alert {
    width: 600px;
    height: 466px;
    background: #ffffff;
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.04);
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -233px;
    margin-left: -300px;
  }

  .alertBox {
    position: relative;
    height: 466px;
  }

  .alert .alertTitle {
    height: 46px;
    line-height: 46px;
    font-family: PingFangSC-Semibold;
    font-size: 18px;
    color: #ffffff;
    letter-spacing: 0.34px;
    background-image: linear-gradient(180deg, #5792e3 0%, #2c59c3 100%);
    border-radius: 10px 10px 0 0;
    text-align: center;
  }

  .alert .alertTitle img {
    float: right;
    margin: 14px 10px 0 0;
    cursor: pointer;
  }

  .alert .alertContent {
    width: 50%;
    margin: 20px auto;
  }

  .alert .alertContent .alertTab {
    position: relative;
  }

  .alert .alertContent .alertTab .tabItem {
    width: 120px;
    height: 30px;
    text-align: center;
    font-family: PingFangSC-Semibold;
    font-size: 16px;
    color: #d7d7d7;
    letter-spacing: 0.3px;
    font-weight: 600;
    cursor: pointer;
  }

  .alert .alertContent .alertTab .tabItem:first-child::after {
    content: "";
    border-right: 1px solid #d7dce7;
    height: 20px;
    position: absolute;
    top: 0;
    left: 50%;
  }

  /* 激活样式 */
  .alert .alertContent .alertTab .tabItem.active {
    border-bottom: 2px solid #2255ce;
    color: #2255ce;
  }

  .scan {
    text-align: center;
    margin: 30px auto;
  }

  .scan p {
    margin: 20px 0;
    text-align: center;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0.22px;
  }

  .down {
    margin: 50px auto;
    text-align: center;
  }

  .bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #f5f5f5;
    border-radius: 0 0 10px 10px;
    text-align: center;
  }

  .bottom .downBut {
    background-image: linear-gradient(180deg, #478ee9 0%, #2255ce 100%);
    border: 1px solid #285ed3;
    border-radius: 4px;
    font-family: PingFangSC-Medium;
    font-size: 14px;
    color: #ffffff;
    letter-spacing: 0;
    width: 138px;
    height: 30px;
    line-height: 30px;
    cursor: pointer;
  }
}
</style>
